import { render } from "./AddonForModelForm.vue?vue&type=template&id=d945f2c8&scoped=true"
import script from "./AddonForModelForm.vue?vue&type=script&lang=js"
export * from "./AddonForModelForm.vue?vue&type=script&lang=js"

import "./AddonForModelForm.vue?vue&type=style&index=0&id=d945f2c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d945f2c8"]])

export default __exports__